import React from 'react';
import { transparentize } from 'polished';
import { colors } from '@keen.io/colors';
import { Icon } from '@keen.io/icons';
import PropertyPath from '../PropertyPath';
import { Container, SearchIcon, Input, Placeholder, Content } from './Property.styles';
import { SEPARATOR } from './constants';

var Property = function Property(_ref) {
  var property = _ref.property,
      placeholder = _ref.placeholder,
      searchPlaceholder = _ref.searchPlaceholder,
      onEditInputChange = _ref.onEditInputChange,
      onEditBlur = _ref.onEditBlur,
      _ref$editMode = _ref.editMode,
      editMode = _ref$editMode === void 0 ? false : _ref$editMode;
  return React.createElement(Container, {
    role: "button",
    tabIndex: 0
  }, React.createElement(Content, null, placeholder && !property && !editMode && React.createElement(Placeholder, null, placeholder), property && !editMode && React.createElement(PropertyPath, {
    path: property.split(SEPARATOR)
  }), editMode && React.createElement(React.Fragment, null, React.createElement(SearchIcon, null, React.createElement(Icon, {
    type: "search",
    fill: transparentize(0.3, colors.blue[500]),
    width: 15,
    height: 15
  })), React.createElement(Input, {
    type: "text",
    autoFocus: true,
    "data-testid": "property-input",
    onBlur: function onBlur(e) {
      return onEditBlur && onEditBlur(e);
    },
    placeholder: property ? property : searchPlaceholder,
    defaultValue: property,
    onChange: function onChange(e) {
      return onEditInputChange && onEditInputChange(e);
    }
  }))));
};

export default Property;